import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { fetchInvoices } from "./getInvoices";
import { format } from "date-fns";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { Dialog, DialogTrigger } from "../ui/dialog";

const InvoiceTable = () => {
  const { invoices } = fetchInvoices();
  //   const {
  //     control,
  //     handleSubmit,
  //     register,
  //     updateInvoiceFn,
  //     isSubmitting,
  //     errors,
  //   } = editInvoice();
  //   const { deleteInvoicesFn } = deleteInvoices();

  return (
    <Table>
      <TableHeader>
        <TableRow className="font-Hemmers text-lg">
          <TableHead>Invoice No.</TableHead>
          <TableHead>Customer</TableHead>
          <TableHead>Date</TableHead>
          <TableHead>Amount</TableHead>
          <TableHead>More</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {invoices?.invoices.map((invoice) => (
          <TableRow
            key={invoice.id}
            className="font-Hemmers text-lg text-black"
          >
            <TableCell>{invoice.invoiceNum}</TableCell>
            <TableCell>test</TableCell>{" "}
            {/* PENDING: Get building name to display */}
            <TableCell>{format(invoice.createdAt, "PPP")}</TableCell>
            <TableCell>{"$" + invoice.totalPrice}</TableCell>
            <TableCell>
              <Popover>
                <PopoverTrigger asChild>
                  <Button className="bg-transparent font-Hemmers text-lg text-black hover:bg-gray-200">
                    ...
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="pointer-events-auto w-24 p-0">
                  <Dialog>
                    <DialogTrigger asChild>
                      <Button className="w-full rounded-b-none rounded-t-md bg-[#FAFAFA] text-black hover:bg-gray-200">
                        Edit
                      </Button>
                    </DialogTrigger>
                  </Dialog>

                  <Dialog>
                    <DialogTrigger asChild>
                      <Button className="w-full rounded-b-md rounded-t-none bg-[#FAFAFA] text-black hover:bg-gray-200">
                        Delete
                      </Button>
                    </DialogTrigger>
                  </Dialog>
                </PopoverContent>
              </Popover>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default InvoiceTable;
